import { useEffect, useState } from 'react';
import { Heading } from '@acb_devel/design-system';
import { Text } from '@acb_devel/design-system';
import { getTotalUsers } from '@services/users';
import { Skeleton } from '@acb_devel/design-system';

import styles from './RegistrationsTableTitle.module.scss';

export function RegistrationsTableTitle() {
  const [totalUsers, setTotalUsers] = useState<null | number>(null);

  useEffect(() => {
    getTotalUsers().then(({ totalUsers }) => {
      setTotalUsers(totalUsers);
    });
  }, []);

  return (
    <div className={styles.registrationsTableTitle}>
      <Heading
        as="h2"
        variant="display-4"
        className={styles.registrationsTableTitle__heading}
      >
        Voluntarios
      </Heading>
      <Skeleton loading={totalUsers === null}>
        <Text
          variant="body-1"
          as="p"
          className={styles.registrationsTableTitle__text}
        >
          <>{totalUsers?.toString()}&nbsp;voluntarios</>
        </Text>
      </Skeleton>
    </div>
  );
}
